module.exports = __webpack_public_path__ + "img/3.Λευκάδα-min.1564b04c.jpg";